<template>
  <div style="width:100%;float:left;">
    <CWidgetDropdown :color="headerColor" :header="'' + data.length" :text="title">
      <template #footer>
        <CCardFooter class="card-footer px-3 py-2 mt-2">
          <CLink
            class="font-weight-bold font-xs btn-block"
            :class="'text-' + headerColor"
            color="info"
            @click="viewOrders()"
          >
            View Orders
            <CIcon name="cil-arrowRight" class="float-right" width="16"/>
          </CLink>
        </CCardFooter>
      </template>
    </CWidgetDropdown>
    <CModal
      title="Open Orders"
      :show.sync="viewModal"
      size="lg"
    >
      <div style="width:100%;float:left;">
        <h4 style="width:100%;float:left;text-align:center;font-size:13px;">Click to go to order.</h4>
        <table class="table" v-if="data">
          <thead>
            <tr>
              <th v-if="$store.state.user.user_type === 'csr'">Rep</th>
              <th>Log#</th>
              <th>Cust</th>
              <th>PO</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="val in data" @click="goToOrder(val)">
              <td v-if="$store.state.user.user_type === 'csr'">{{val.order.rep.name}}</td>
              <td>{{val.as400_log_number}}</td>
              <td>{{val.customer_name}}</td>
              <td>{{val.po_number}}</td>
              <td>{{val.local_created_at}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </CModal>
  </div>
</template>
<script>
var methods = {}

methods.getNewOrders = function () {
  const postData = {
    customer: this.customer_selected,
    type: this.type
  }
  axios.post(this.$apiAdress + '/api/orders/getUpcoming?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.data = response.data
    this.$emit('set', 'upcoming_' + this.type)
  }).catch(e => {
    console.log(e)
  })
}

methods.goToOrder = function (val) {
  this.$router.push('/order/' + val.order_id + '/' + val.order_group_id)
}

methods.viewOrders = function () {
  this.viewModal = true
}

export default {
    // ===Component name
    name: "UpcomingOrdersWidget",
    // ===Props passed to component
    props: ['csr', 'customer_selected', 'type', 'title', 'headerColor'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
          data: [],
          viewModal: false
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      this.getNewOrders()
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
